import { useState, useCallback } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useAddableTag = /* @__PURE__ */ __name((onAdd) => {
  const [value, setValue] = useState(null);
  const handleOnAdd = useCallback(
    ({ key }) => {
      if (key === "Enter" && value !== null && value !== "") {
        onAdd(value);
        setValue("");
      }
    },
    [onAdd, value, setValue]
  );
  const handleChange = /* @__PURE__ */ __name((e) => {
    setValue(e.currentTarget.value);
  }, "handleChange");
  return {
    handleChange,
    handleOnAdd,
    setValue,
    value
  };
}, "useAddableTag");

export { useAddableTag };
//# sourceMappingURL=use-addable-tag.js.map
